import React from "react";
import { AppContextProvider } from "./components/AppContext";
import Main from "./components/Main";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { LoanForm } from "./components/Forms/LoanForm";
import { BrowserRouter as Router } from "react-router-dom";
import "rc-slider/assets/index.css";
import "react-circular-progressbar/dist/styles.css";
import "./App.css";

const App = () => {
  return (
    <Router basename={process.env.REACT_APP_BASE_SLUG}>
      <AppContextProvider>
        <Header />
        <Main>
          <div className="form-wrapper">
            <LoanForm></LoanForm>
          </div>
        </Main>
        <Footer />
      </AppContextProvider>
    </Router>
  );
};

export default App;
